<template>
  <v-layout :class="styles" column>
    <v-menu transition="slide-y-transition" top>
      <template v-slot:activator="{ on }">
        <p class="ma-0 px-4 notifyTitle">
          <a v-on="on">
            【重要】サービス終了のお知らせ
          </a>
        </p>
      </template>
      <v-card class="pa-2">
        <div class="pa-2">
          <v-subheader :class="[headerStyles, 'px-2']">
            【重要】サービス終了のお知らせ
          </v-subheader>
          <p class="mt-4">
            平素より本サービスをご利用いただき、誠にありがとうございます。
          </p>
          <p>
            2025年6月19日公表させていただいた通り、誠に勝手ながら本サービスを終了させていただく運びとなりました。<br />
            サービス終了に伴い、最終入稿日（案件予算申請日）および広告配信終了日を以下のとおり設定させていただいております。
          </p>
          <ul>
            <li>
              <strong>最終入稿日（新規の案件予算申請日）：</strong>2025年8月31日
            </li>
            <li><strong>広告配信終了日：</strong>2025年10月31日</li>
          </ul>
          <p class="mt-4">
            これまでご利用いただきました、広告主様および関係各位には深く感謝申し上げますとともに、<br />
            ご不便をおかけいたしますことをお詫び申し上げます。<br />
            残りの期間につきましても、何卒よろしくお願い申し上げます。
          </p>
        </div>
        <AppButtonOk small>閉じる</AppButtonOk>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import { css } from 'emotion'
import dayjs from 'dayjs'

export default {
  name: 'HolidaysInformation',
  computed: {
    styles() {
      return css`
        display: flex;
        align-items: flex-start;
        justify-content: center;
        font-size: 12px;
        overflow: hidden;
      `
    },
    headerStyles() {
      return css`
        font-size: 16px !important;
      `
    },
  },
  methods: {
    isBefore(datetime) {
      return dayjs().isBefore(datetime)
    },
  },
}
</script>

<style scoped>
.notifyTitle {
  font-size: 14px;
}
</style>
